import { css } from "../../../component-styles";

export const list = css`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: var(--text-pri);
  }
  p {
    color: var(--text-pri);
  }
  blockquote {
    color: var(--text-ter);
  }
  a {
    color: var(--text-pri);
  }
  .blog-post-date {
    color: var(--text-ter);
  }
  .blog-post-category {
    color: var(--text-sec);
  }
  .tag {
    color: var(--text-sec);
  }
  .search-input {
    color: var(--text-sec);
  }
`;
